
import {  Alert, Box, Button, DialogActions, DialogContent, DialogTitle, Grid,  LinearProgress,  Paper, TextField } from '@mui/material';
import { useState } from 'react';
import {  AutoCompleteCliente01, AutoCompleteOperacoes01, VSwitch, VSwitch01, VSwitch02 } from '../../../shared/forms';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import { Relatorios } from '../../../shared/services/api/relatorios/relatorios';
import RelatorioVendasfabrica from './relatoriosvendafabrica';
import RelatorioVendasfabricacliente from './relatoriosvendafabricacliente';
import { AutoCompleteFabrica01 } from '../../../shared/forms/AutoCompleteFabrica01';
import RelatorioVendasFabricaDetalhada from './relatoriosvendafabricadetalhada';

           
export const RelatoriosVendasfabrica: React.FC = () => {                      
  const [isLoading, setIsLoading] = useState(false);         
  const [uuidfabrica, setUidfabrica] = useState('');  
  const [uuidoperacao, setUidoperacao] = useState('');  
  const [nome, setnome] = useState(''); 
  const [msg, setMsg] = useState('');  
  const [openalert, setOpenAlert] = useState(false); 
  const [Detalhado, setDetalhado] = useState(false);  
  const [porcliente, setporcliente] = useState(false);                   
  const [dataInicial, setDataInicial] = useState<Dayjs | null>(dayjs()); 
  const [dataFinal, setDataFinal] = useState<Dayjs | null>(dayjs());      
              
  const handleSave = () => {      
    if(porcliente === false && Detalhado === false){                       
    Relatorios             
      .RelatorioVendasfabrica( uuidfabrica, uuidoperacao,porcliente, Detalhado, dayjs(dataInicial).format('DD/MM/YYYY'), dayjs(dataFinal).format('DD/MM/YYYY'))   
      .then((result) => {          
        setIsLoading(false);              
        if (result instanceof Error) { 
          setMsg(result.message); 
          setOpenAlert(true);                              
        }else {   
          if(result.length > 0){   
              RelatorioVendasfabrica(result, nome, `Período :${dayjs(dataInicial).format('DD/MM/YYYY')} a  ${dayjs(dataFinal).format('DD/MM/YYYY')}`);  
          }else{
            setMsg('Não a Registros');
            setOpenAlert(true);
          }
        }       
      });   
    }else if(porcliente === true && Detalhado === false){
      Relatorios             
      .RelatorioVendasfabricacliente( uuidfabrica, uuidoperacao,porcliente, Detalhado, dayjs(dataInicial).format('DD/MM/YYYY'), dayjs(dataFinal).format('DD/MM/YYYY'))   
      .then((result) => {          
        setIsLoading(false);              
        if (result instanceof Error) { 
          setMsg(result.message); 
          setOpenAlert(true);                              
        }else {   
          if(result.length > 0){
              RelatorioVendasfabricacliente(result, nome, `Período :${dayjs(dataInicial).format('DD/MM/YYYY')} a  ${dayjs(dataFinal).format('DD/MM/YYYY')}`); 
          }else{
            setMsg('Não a Registros');
            setOpenAlert(true);
          }
        }       
      });   
        } else if(porcliente === false && Detalhado === true){
          Relatorios             
          .RelatorioVendasfabricadetalhes( uuidfabrica, uuidoperacao,porcliente, Detalhado, dayjs(dataInicial).format('DD/MM/YYYY'), dayjs(dataFinal).format('DD/MM/YYYY'))   
          .then((result) => {          
            setIsLoading(false);              
            if (result instanceof Error) { 
              setMsg(result.message); 
              setOpenAlert(true);                              
            }else {   
              if(result.length > 0){
                  RelatorioVendasFabricaDetalhada(result, nome, `Período :${dayjs(dataInicial).format('DD/MM/YYYY')} a  ${dayjs(dataFinal).format('DD/MM/YYYY')}`); 
              }else{
                setMsg('Não a Registros');
                setOpenAlert(true);
              }
            }       
          });   
            }  else if(porcliente === true && Detalhado === true){
              Relatorios             
              .RelatorioVendasfabricadetalhes( uuidfabrica, uuidoperacao,porcliente, Detalhado, dayjs(dataInicial).format('DD/MM/YYYY'), dayjs(dataFinal).format('DD/MM/YYYY'))   
              .then((result) => {          
                setIsLoading(false);              
                if (result instanceof Error) { 
                  setMsg(result.message); 
                  setOpenAlert(true);                              
                }else {   
                  if(result.length > 0){
                      RelatorioVendasFabricaDetalhada(result, nome, `Período :${dayjs(dataInicial).format('DD/MM/YYYY')} a  ${dayjs(dataFinal).format('DD/MM/YYYY')}`); 
      
                  }else{
                    setMsg('Não a Registros');
                    setOpenAlert(true);
                  }
                }       
              });   
                }           
  };          
   const handleCloseAlert = (
      event?: React.SyntheticEvent | Event,
      reason?: SnackbarCloseReason,
    ) => {
      if (reason === 'clickaway') {
        return;
      }                        
      setOpenAlert(false);
    };
  const handlefabrica= (uuidfabrica: string | undefined) => {    
    if (uuidfabrica != null) {     
      setUidfabrica(uuidfabrica);                  
    }else{                       
      setUidfabrica('');                         
    }                 
  };  
  const handleoperacao= (uuidoperacao: string | undefined) => {    
    if (uuidoperacao!= null) {     
      setUidoperacao(uuidoperacao);                  
    }else{                       
      setUidoperacao('');                         
    }                 
  }; 
  const handnome= (nome: string | undefined) => {    
    if (nome!= null) {     
      setnome(nome);                  
    }else{                       
      setnome('');                         
    }                 
  };  
  
    
 

  return (
    <Box  alignItems="center" width='auto' alignContent='center' height="auto"  display="flex" flexDirection="column"  >
     <Snackbar 
                open={openalert}        
                autoHideDuration={1200}           
                onClose={handleCloseAlert}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}  
              >
            <Alert  
              onClose={handleCloseAlert}        
              severity="error"         
              variant="filled"                
              sx={{ width: '100%' }}            
            >         
              {msg}           
            </Alert>         
          </Snackbar>
      <Box gap={1}  padding={1} paddingX={2} display="flex" alignItems="center" alignSelf='center' width='80%' height="20%" margin={1}  alignContent='center'></Box>
      <Box   width='auto' alignItems="center"  component={Paper} height="auto" margin={1} 
      
        alignContent='center'>       
        <DialogTitle>Relatório de Vendas Por Fabrica</DialogTitle>
        <DialogContent  dividers>    
          
          {isLoading && (           
            <Grid item>  
              <LinearProgress variant='indeterminate' />  
            </Grid>                      
          )}   
          <Grid container  padding={1} item direction="row" gap={2}>
            <Grid container spacing={2} item direction="row" xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <AutoCompleteFabrica01
                  uuidfabrica={handlefabrica} 
                  nome={handnome}
                />                    
              </Grid> 
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <AutoCompleteOperacoes01
                  uuidoperacao={handleoperacao} 
                />                  
              </Grid> 
              
              <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    format='DD/MM/YYYY'    
                    value={dataInicial}
                    onChange={(newValue) => setDataInicial(newValue)} 
                    label='Data Inicial'
                    slotProps={{
                      textField: {    
                        size:'small',
                      }
                    }}
                  />
                </LocalizationProvider>   
              </Grid>     
              <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>  
                  <DatePicker
                    format='DD/MM/YYYY'
                    value={dataFinal}
                    onChange={(newValue) => setDataFinal(newValue)} 
                    label='Data Final'
                    slotProps={{
                      textField: {    
                        size:'small',
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>  
              <Grid item xs={2} sm={2} md={2} lg={2} xl={3}>          
                 <VSwitch02
                    name="porcliente"
                    label="Cliente"
                    fdisabled={false}
                    aliamento="start"
                    initialValue={porcliente} // Passa o estado atual do pai como valor inicial
                    valor={(novoEstado) => setporcliente(novoEstado ?? true)}
                  /> 
               </Grid>    
              <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>          
               <VSwitch02
                name="detalhado"
                label="detalhado"
                fdisabled={false}
                aliamento="start"
                initialValue={Detalhado} // Passa o estado atual do pai como valor inicial
                valor={(novoEstado) => setDetalhado(novoEstado ?? true)} // Atualiza o estado no pai
                />
           </Grid>
           </Grid>        
          </Grid>         
        </DialogContent>     
        <DialogActions>
          <Button sx={{ minWidth:'30%'  }} variant='outlined' autoFocus onClick={handleSave}>Visualizar</Button>
        </DialogActions>
      </Box>
    </Box>
  );
};   